import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";

const gbp = (n) => `£${Number(n).toLocaleString("en-GB", { minimumFractionDigits: 0 })}`;

export default function OrderConfirmation() {
    const { id } = useParams();
    const [order, setOrder] = useState(null);
    const [attempts, setAttempts] = useState(0);

    useEffect(() => {
        let mounted = true;
        const tick = async () => {
            try {
                const { data } = await api.get(`/payments/order-status/${id}`);
                if (!mounted) return;
                setOrder(data);
                if (data.status !== "paid" && attempts < 10) {
                    setTimeout(() => setAttempts((a) => a + 1), 1500);
                }
            } catch (e) {
                console.error(e);
            }
        };
        tick();
        return () => {
            mounted = false;
        };
    }, [id, attempts]);

    if (!order) return <div className="loading">Confirming your order…</div>;

    const paid = order.status === "paid";
    const failed = order.status === "failed";

    return (
        <div className="content-page" data-testid="order-confirmation-page">
            <div className="eyebrow" style={{ marginBottom: 16 }}>Order {id.slice(-8)}</div>
            <h1>
                {paid ? (
                    <>Thank you — your pieces are on their <em>way.</em></>
                ) : failed ? (
                    <>Something went <em>sideways.</em></>
                ) : (
                    <>Confirming your <em>payment…</em></>
                )}
            </h1>
            <p className="lede">
                {paid
                    ? `A confirmation is on its way to ${order.email}. We'll email again the moment it ships.`
                    : failed
                    ? "Your payment couldn&rsquo;t be completed. Please try again or contact us at hello@raxtheedit.com."
                    : "Just checking with our payment provider — this usually takes a couple of seconds."}
            </p>

            <section>
                <h2>What you're taking home</h2>
                {(order.line_items || []).map((li, i) => (
                    <div
                        key={i}
                        style={{
                            display: "grid",
                            gridTemplateColumns: "80px 1fr auto",
                            gap: 16,
                            padding: "12px 0",
                            borderBottom: "1px solid var(--sand-line)",
                            alignItems: "center",
                        }}
                    >
                        {li.image && (
                            <img src={li.image} alt={li.title} style={{ width: 80, height: 100, objectFit: "cover" }} />
                        )}
                        <div>
                            <div style={{ fontFamily: "var(--font-sans)", fontSize: 10, letterSpacing: "0.24em", textTransform: "uppercase", color: "var(--sand)" }}>
                                {li.designer}
                            </div>
                            <div style={{ fontFamily: "var(--font-serif)", color: "var(--cocoa)" }}>{li.title}</div>
                        </div>
                        <strong style={{ fontFamily: "var(--font-serif)" }}>{gbp(li.price)}</strong>
                    </div>
                ))}
                <div style={{ marginTop: 16, textAlign: "right", fontFamily: "var(--font-serif)", fontSize: "1.2rem" }}>
                    Total <strong>{gbp(order.total)}</strong>
                </div>
            </section>

            <div style={{ marginTop: 40 }}>
                <Link to="/shop" className="btn btn-outline" data-testid="order-continue-shopping">
                    Continue browsing
                </Link>
            </div>
        </div>
    );
}
